import { useLocalStore } from 'mobx-react-lite';

import { ICommonPopupsProps } from '@gem/popups';

export interface INewContactPopupParams {
  navigateToActiveGroup?: boolean;
}

interface INewContactPopupPresenter {
  hasBackButton: boolean;
  onClose(): void;
  onBack(): void;
}

export function useNewContactPopupPresenter({
  popupInstance,
  onClose,
  onBack,
}: ICommonPopupsProps<INewContactPopupParams | undefined>): INewContactPopupPresenter {
  return useLocalStore<INewContactPopupPresenter>(() => ({
    get hasBackButton(): boolean {
      return !!onBack;
    },

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    onBack(): void {
      popupInstance.close();
      onBack?.();
    },
  }));
}
